// One-off frontend-only production override for a stuck live transaction.
// This must not be used to drive backend transaction logic or trigger Sharetribe transitions.
export const STUCK_LIVE_RECEIVED_TRANSACTION_ID = '69e1925a-4659-4018-887a-413abb71399f';
export const STUCK_LIVE_RECEIVED_STATUS_LABEL = 'Received';

// Sharetribe transaction process versions are immutable. Legacy PayPal orders whose
// receive transition incorrectly required a Stripe payout are completed by the server
// with an operator-only metadata marker instead.
export const LEGACY_PAYPAL_RECEIVED_META_KEY = 'legacyPayPalReceived';

// Temporary frontend-only fallback for a live transaction that cannot be canceled from backend.
// Keep this isolated to display/state guards only. Do not use it to call transition/update APIs.
export const FRONTEND_CANCELED_TRANSACTION_ID = '6a161848-6b3d-44b3-84fa-fe44ef382564';
export const FRONTEND_CANCELED_STATUS_LABEL = 'Canceled';

const getTransactionId = transactionOrId =>
  typeof transactionOrId === 'string'
    ? transactionOrId
    : transactionOrId?.id?.uuid || transactionOrId?.uuid;

export const isStuckLiveReceivedTransaction = transactionOrId => {
  const transactionId = getTransactionId(transactionOrId);

  return transactionId === STUCK_LIVE_RECEIVED_TRANSACTION_ID;
};

export const isLegacyPayPalReceivedTransaction = transaction => {
  const receivedMarker = transaction?.attributes?.metadata?.[LEGACY_PAYPAL_RECEIVED_META_KEY];

  return receivedMarker?.status === 'received' && Boolean(receivedMarker?.recordedAt);
};

export const isFrontendCanceledTransaction = transactionOrId => {
  const transactionId = getTransactionId(transactionOrId);

  return transactionId === FRONTEND_CANCELED_TRANSACTION_ID;
};
